import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'leaflet/dist/leaflet.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import "./vee-validate";

Vue.config.productionTip = false

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(VueAxios, axios)

new Vue({
  router,
  store,
  vuetify,
  created() {
    // axios.defaults.withCredentials = true
    // axios.defaults.headers.common['Access-Control-Allow-Origin']=`http://localhost:8080/`
    // axios.defaults.headers.common['Access-Control-Allow-Credentials']=true
    // axios.defaults.headers.common['Access-Control-Allow-Headers']=`Origin, X-Requested-With, Content-Type, Accept`
    const validToken = localStorage.getItem('token')
    if( validToken != null){
      let credentials = {
        login: localStorage.getItem('login'),
        password:localStorage.getItem('password'),
        token: localStorage.getItem('token'),
      }
      if(credentials){
        this.$store.commit('SET_USER_DATA',credentials)
      }
    } else if(localStorage.getItem('login') && localStorage.getItem('password')){
      let credentials = {
        login: localStorage.getItem('login'),
        password: localStorage.getItem('password'),
      }
      var aes256 = require('aes256');
      var key = 'd41d8cd98f00b204e9800998ecf8427e';
      console.log(aes256.decrypt(key,JSON.parse(localStorage.getItem('login'))))
      console.log(aes256.decrypt(key,JSON.parse(localStorage.getItem('password'))))
      console.log('nie ma tokenu')
      console.log(aes256.decrypt(key,credentials.login))

      console.log(aes256.decrypt(key,credentials.password))
      this.$store.dispatch('login',credentials)
    }
    /*
    axios.interceptors.response.use(
      response => response,
      error =>{
         
        if(error.response.status === 401){
          
         
          //WSTAWIENIE TEGO BEDZIE WYLOGOWYWAC PO OTRZYMANIU 401
           
          this.$store.dispatch('logout')
          
        }
        return Promise.reject(error)
        
      }
    )
    */
  },
  render: h => h(App)
}).$mount('#app')
